import { assert } from '@sparkdotfi/common-universal'

import { TxOverview } from '../../logic/createTxOverview'
import { UnstakeTransactionOutcome } from './UnstakeTransactionOutcome'
import { Token } from '@/domain/types/Token'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'

export interface UnstakeTransactionOverviewProps {
  txOverview: TxOverview
  selectedToken: Token
}

export function UnstakeTransactionOverview({ txOverview }: UnstakeTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    const placeholder = '-'

    return (
      <TransactionOverview providedBy="sky">
        <TransactionOverview.Row>
          <TransactionOverview.Label>Outcome</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      </TransactionOverview>
    )
  }
  const { rewardToken, routeToOutcomeToken, earnedRewards, isExiting, farmName } = txOverview

  assert(routeToOutcomeToken.length > 0, 'Route must have at least one item')
  const outcomeTokenRouteItem = routeToOutcomeToken.at(-1)!

  return (
    <TransactionOverview providedBy="sky">
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <HorizontalScroll>
          <TransactionOverview.Generic>
            <UnstakeTransactionOutcome
              outcomeTokenRouteItem={outcomeTokenRouteItem}
              rewardToken={rewardToken}
              isExiting={isExiting}
              earnedRewards={earnedRewards}
              farmName={farmName}
            />
          </TransactionOverview.Generic>
        </HorizontalScroll>
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  UnstakeTransactionOverview as TransactionOverview,
  type UnstakeTransactionOverviewProps as TransactionOverviewProps,
}
